var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEarningThree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.000244141,
    width: 42.7463,
    height: 42.7463,
    rx: 5.34328,
    fill: "#C4FFE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8002 17.8002H24.2002M16.2002 13.8002L19.4002 14.6002L21.0002 12.2002L22.6402 14.6002L25.8002 13.8002L23.4002 17.8002V18.6002L27.2002 21.1442C27.6936 21.5756 28.0427 22.148 28.2002 22.7842L29.8002 28.8082C29.8299 28.928 29.8315 29.053 29.8048 29.1735C29.7781 29.294 29.7239 29.4067 29.6464 29.5027C29.569 29.5988 29.4703 29.6756 29.3582 29.7272C29.2461 29.7788 29.1236 29.8038 29.0002 29.8002H13.0002C12.8769 29.8038 12.7543 29.7788 12.6422 29.7272C12.5301 29.6756 12.4315 29.5988 12.354 29.5027C12.2766 29.4067 12.2224 29.294 12.1957 29.1735C12.169 29.053 12.1706 28.928 12.2002 28.8082L13.8002 22.7842C13.9665 22.144 14.327 21.5711 14.8322 21.1442L18.6002 18.6002V17.8002L16.2002 13.8002Z",
    stroke: "#0DA06A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarningThree);
export default __webpack_public_path__ + "static/media/earning-three.b3eac92684c7cbdfcdd6b1b44439456f.svg";
export { ForwardRef as ReactComponent };